import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  actionBadgeClass,
  auditActorLabel,
  formatAuditWhen,
  stepsChangeLabel
} from '../../utils/flow-audit.utils';

@Component({
  selector: 'tr[app-flow-audit-row]',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flow-audit-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlowAuditRowComponent {
  @Input({ required: true }) row!: any;
  @Input() busyId: number | null = null;
  @Output() restore = new EventEmitter<any>();

  readonly formatWhen = formatAuditWhen;
  readonly badgeClass = actionBadgeClass;
  readonly actorLabel = auditActorLabel;
  readonly stepsLabel = stepsChangeLabel;

  isBusy(): boolean {
    return this.busyId === this.row?.id;
  }

  anyBusy(): boolean {
    return this.busyId !== null;
  }

  onRestore(): void {
    this.restore.emit(this.row);
  }
}
